import axios from "axios";
import localforage from "localforage";
import * as data from "search-observe-app/plugins/data.js";
import { extendPrototype as startswith } from "localforage-startswith";
import { extendPrototype as remove } from "localforage-removeitems";
import { reactive } from "vue";
startswith(localforage);
remove(localforage);

let appStore = null;
export function setPluginStore(store) {
  appStore = store;
}
const ACCURACY_THRESHOLD = 500;
const MAX_FIX_AGE_MS = 15000;
export default {
  data,

  submitter: [],
  required() {
    return [(v) => !!v || "Required"];
  },

  showMessage(msg) {
    alert(msg);
  },

  //Posts the records and resolves to { uploaded, failed, offline } so
  //submitData can report every table in one message
  submit(submitInfo) {
    let endpoint;
    console.log("submitting data to database");
    if (!("key" in submitInfo)) {
      submitInfo.key = "p";
    }
    if ("endpoint" in submitInfo) {
      endpoint = `${appStore.getters["shared/dbName"]}${submitInfo["endpoint"]}`;
    } else {
      endpoint = `${appStore.getters["shared/dbName"]}/public/${submitInfo.table}/keys/${submitInfo.key}/`;
    }
    if (!submitInfo.payload.length || submitInfo.table == "") {
      return Promise.resolve({ uploaded: 0, failed: 0 });
    }
    return axios
      .post(endpoint, JSON.stringify(submitInfo.payload))
      .then((response) => {
        if (response.status === 200) {
          let rowsInserted = 0;
          for (let i in response.data.message) {
            if (
              response.data.status[i] != "error" &&
              response.data.message[i].search("inserted") > -1
            ) {
              this.markSubmitted(submitInfo.storageKeys[i], submitInfo.payload[i]);
              rowsInserted = rowsInserted + 1;
            }
          }
          appStore.commit("shared/setUnsavedData", false);
          return {
            uploaded: rowsInserted,
            failed: submitInfo.payload.length - rowsInserted
          };
        } else {
          console.log("failure toast, response code = " + response.status);
          return { uploaded: 0, failed: submitInfo.payload.length };
        }
      })
      .catch((err) => {
        console.log("error posting", err);
        appStore.commit("shared/setUnsavedData", true);
        //the server couldn't be reached, which affects every table at once
        return { uploaded: 0, failed: submitInfo.payload.length, offline: true };
      });
  },
  //Flag the stored copy of an uploaded record as submitted. Only the flag is
  //changed so the record isn't run back through saveLocal (which would see the
  //type-forced payload as an edit and reset submitted). Skipped if the record
  //was edited while the upload was in flight so that edit still gets sent.
  async markSubmitted(key, uploaded) {
    const stored = await localforage.getItem(key);
    if (stored && (stored.edit_ts || "") === (uploaded.edit_ts || "")) {
      stored.submitted = true;
      await localforage.setItem(key, stored);
    }
  },
  //survey_ts is stored as "YYYY-MM-DD HH:MM:SS" which Safari can't reliably
  //parse; the "T" separated form is parsed as local time by all browsers
  parseTimestamp(ts) {
    if (typeof ts === "string") {
      return new Date(ts.replace(" ", "T"));
    }
    return new Date(ts);
  },

  getApiRefData: function (varName) {
    let endpoint = appStore.getters["shared/dbName"] + "/ref/" + varName + "/";
    this.getApiData(endpoint, varName, "refTables");
  },

  getViewApiData: function (varName) {
    let endpoint = `${appStore.getters["shared/dbName"]} /public/${varName}/`;
    this.getApiData(endpoint, varName, "views");
  },
  //retrieve data from backend API and store in store and localforage
  getApiData: function (endpoint, varName, holder) {
    let payload = { tableName: varName, tableType: holder };
    axios
      .get(endpoint)
      .then(async (response) => {
        payload["records"] = response.data.sort(
          (a, b) => a.sequence - b.sequence
        );
        if (holder === "dataTables") {
          //rows from the database must not be queued for upload
          payload.records = await this.saveDownloadedRecords(
            payload.tableName,
            payload.records
          );
        } else {
          //remove current localforage and replace
          this.deleteLocalTable(payload.tableName);
          this.saveRecords({
            table: payload.tableName,
            records: payload.records
          });
        }
        //write the records to store
        appStore.dispatch("shared/refreshRecords", payload);
      })
      .catch((err) => {
        console.log(payload.tableName);
        console.log(err);
        if (payload.tableName.includes("ref")) {
          //can't connect so restore from local
          this.restoreRefFromLocal(payload.tableName);
        }
      });
  },
  async restoreFromLocal(tableName) {
    await localforage
      .startsWith(`${appStore.getters["shared/dbName"]}-${tableName}`)
      .then((result) => {
        let records = this.forceFieldTypes(tableName, Object.values(result));
        appStore.dispatch("shared/refreshRecords", {
          tableName: tableName,
          records: records,
          tableType: "dataTables"
        });
      });
  },
  async restoreRefFromLocal(tableName) {
    await localforage
      .startsWith(`${appStore.getters["shared/dbName"]}-${tableName}`)
      .then((result) => {
        let records = this.forceFieldTypes(tableName, Object.values(result));
        appStore.dispatch("shared/refreshRecords", {
          tableName: tableName,
          records: records,
          tableType: "refTables"
        });
      });
  },
  getFields(tableName) {
    switch (tableName) {
      case data.SURVEYEFFORT:
        return data.SURVEYEFFORTFIELDS;
      case data.SURVEYPRIMARY:
        return data.SURVEYPRIMARYFIELDS;
      case data.SURVEYBREADCRUMB:
        return data.SURVEYBREADCRUMBFIELDS;
      case data.SURVEYPRIMARYPHOTO:
        return data.PHOTOFIELDS;
      case data.SURVEYSECONDARYPHOTO:
        return data.PHOTOFIELDS;
      case data.SURVEYTERTIARYPHOTO:
        return data.PHOTOFIELDS;
      case data.SURVEYSECONDARY:
        return data.SURVEYSECONDARYFIELDS;
    }
  },
  forceFieldTypes(tableName, records) {
    let header = this.getFields(tableName);
    if (header !== undefined) {
      for (let item in records) {
        try {
          records[item] = this.forceFieldType(header, records[item]);
        } catch (err) {
          console.log(err);
        }
      }
    }
    return records;
  },
  forceFieldType(header, record) {
    for (let a in record) {
      if (record[a] != null && record[a].length < 1) {
        delete record[a];
        continue;
      }
      if (
        header
          .filter(function (el) {
            return el["type"] === "number";
          })
          .map((a) => a.key)
          .includes(a)
      ) {
        record[a] = Number(record[a]);
      }
      if (
        header
          .filter(function (el) {
            return el["type"] === "boolean";
          })
          .map((a) => a.key)
          .includes(a)
      ) {
        record[a] = String(record[a]);
      }
    }
    return record;
  },
  //check if the survey_ts value is more than 24 hours old and submit === true
  // delete record from local forage if both cases are true.
  removeOldRecords(submitInfo) {
    return new Promise((resolve) => {
      let date_cuttoff = new Date(Date.now() - 24 * (60 * 60 * 1000));
      var ts_field;
      if (submitInfo.table.includes("photo")) {
        ts_field = "ts";
      } else {
        ts_field = "survey_ts";
      }
      //use the localforage keys directly, rebuilding them from the table key
      //fields doesn't match how every table's records are saved
      let these_keys = Object.keys(submitInfo.records).filter((key) => {
        let rec = submitInfo.records[key];
        return this.parseTimestamp(rec[ts_field]) < date_cuttoff && rec.submitted;
      });
      localforage.removeItems(these_keys).then(() => {
        resolve();
      });
    });
  },

  //Delete records based on key matching tablename
  deleteLocalTable(tableName) {
    var myLength = tableName.length;
    Object.keys(localStorage).forEach(function (key) {
      if (key.includes(tableName)) {
        localStorage.removeItem(key);
      }
    });
  },
  //dt is when the user logged in or started a new search. Offer to resume
  //the user's most recent search if it started within 12 hours of dt
  findUnfinishedSearch(dt) {
    //apps without a survey effort table (search-trials) have nothing to resume
    if (!data.SURVEYEFFORT) {
      return;
    }
    const cutoff = new Date(dt - 12 * (60 * 60 * 1000));
    //don't offer the search that is currently open
    const position = appStore.getters["shared/tablePositions"][data.SURVEYEFFORT];
    const surveys = appStore.getters["shared/dataTables"][data.SURVEYEFFORT];
    const current =
      position > -1 && surveys !== undefined ? surveys[position] : null;
    localforage
      .startsWith(`${appStore.getters["shared/dbName"]}-${data.SURVEYEFFORT}`)
      .then((result) => {
        let survey_records = Object.values(result)
          .filter((el) => {
            return (
              this.parseTimestamp(el["survey_ts"]) >= cutoff &&
              el["observer_code"] === appStore.getters["shared/username"] &&
              !(
                current &&
                current.survey_ts === el.survey_ts &&
                current.survey_tablet === el.survey_tablet
              )
            );
          })
          .sort(
            (a, b) =>
              this.parseTimestamp(b.survey_ts) - this.parseTimestamp(a.survey_ts)
          );
        if (survey_records.length === 0) {
          return;
        }
        const lastSurvey = survey_records[0];
        this.isSearchUnfinished(lastSurvey).then((unfinished) => {
          if (unfinished) {
            appStore.commit("shared/setAttribute", {
              attribute: "unfinishedSearch",
              value: lastSurvey
            });
          }
        });
      });
  },
  //A search is unfinished until a breadcrumb has been dropped at every
  //location. Apps without breadcrumb locations (at-sea) have no way to finish
  //a search so any recent search counts as unfinished.
  async isSearchUnfinished(survey) {
    const locations = await this.getBreadcrumbLocations();
    //BreadCrumb.vue only shows locations when there is more than one
    if (locations.length <= 1) {
      return true;
    }
    const crumbs = await localforage.startsWith(
      `${appStore.getters["shared/dbName"]}-${data.SURVEYBREADCRUMB}`
    );
    const visited = new Set(
      Object.values(crumbs)
        .filter(
          (el) =>
            el.survey_ts === survey.survey_ts &&
            el.survey_tablet === survey.survey_tablet
        )
        .map((el) => el.breadcrumb_location_code)
    );
    return locations.some((location) => !visited.has(location.code));
  },
  //Breadcrumb locations from the store, falling back to the local copy when
  //the reference tables haven't loaded from the API yet. Reference records are
  //saved without the dbName prefix (see saveReferenceTable).
  async getBreadcrumbLocations() {
    if (!data.REFBREADCRUMB) {
      return [];
    }
    const refs = appStore.getters["shared/refTables"][data.REFBREADCRUMB];
    if (refs && refs.length > 0) {
      return refs;
    }
    const local = await localforage.startsWith(data.REFBREADCRUMB);
    return Object.values(local).filter(
      (el) => el.table === data.REFBREADCRUMB
    );
  },
  //Save Records writes an array of record objects to local forage
  saveRecords(info) {
    info.records.map((r) => this.saveRecord(info.table, r));
  },
  saveRecord(tableName, record) {
    record.table = tableName;
    if (tableName.includes("ref")) {
      return this.saveReferenceTable(tableName, record);
    }
    switch (tableName) {
      case data.SURVEYBREADCRUMB:
        return this.saveBreadCrumbLocally(record);
      case data.SURVEYEFFORT:
        return this.saveSurveyEffortLocally(record);
      case data.SURVEYPRIMARY:
        return this.saveObservationLocally(tableName, record);
      case data.SURVEYSECONDARY:
        return this.saveObservationLocally(tableName, record);
      case data.SURVEYTERTIARY:
        return this.saveObservationLocally(tableName, record);
      case data.SURVEYPRIMARYPHOTO:
        return this.savePhotoLocally(tableName, record);
      case data.SURVEYSECONDARYPHOTO:
        return this.savePhotoLocally(tableName, record);
      case data.SURVEYTERTIARYPHOTO:
        return this.savePhotoLocally(tableName, record);
    }
  },
  makeNewRecord(table) {
    let fields = this.getFields(table);
    let record = {};
    fields.forEach((field) => {
      record[field.key] = field.default ? record[field.default] : "";
    });
    return record;
  },

  makeNewObservation(table) {
    let record = this.makeNewRecord(table);
    record["survey_tablet"] = appStore.getters["shared/tabletCode"];
    record["survey_ts"] = this.provideRecord(data.SURVEYEFFORT)["survey_ts"];
    record["latitude_wgs84"] = this.getLatitude(); //This gets overwritten in form if programmed todo so
    record["longitude_wgs84"] = this.getLongitude();
    appStore.dispatch("shared/addRecord", { table: table, record: record });
    appStore.dispatch("shared/shiftPosition", {
      table: table,
      position: appStore.getters["shared/dataTables"][table].length - 1
    });
    return record;
  },
  newBreadCrumb() {
    let record = {
      survey_tablet: appStore.getters["shared/tabletCode"],
      survey_ts: this.provideRecord(data.SURVEYEFFORT)["survey_ts"],
      breadcrumb_location_code: "",
      latitude_wgs84: this.getLatitude(),
      longitude_wgs84: this.getLongitude(),
      ts: ""
    };
    appStore.dispatch("shared/addRecord", {
      table: data.SURVEYBREADCRUMB,
      record: record
    });
    appStore.dispatch("shared/shiftPosition", {
      table: data.SURVEYBREADCRUMB,
      position:
        appStore.getters["shared/dataTables"][data.SURVEYBREADCRUMB].length - 1
    });
    return record;
  },
  newSurveyEffort() {
    let record = this.makeNewRecord(data.SURVEYEFFORT);

    record.survey_tablet = appStore.getters["shared/tabletCode"];
    record.observer_code = appStore.getters["shared/username"];
    record.survey_ts = this.getLocalTimestamp(new Date());

    appStore.dispatch("shared/addRecord", {
      table: data.SURVEYEFFORT,
      record: record
    });
    appStore.dispatch("shared/shiftPosition", {
      table: data.SURVEYEFFORT,
      position:
        appStore.getters["shared/dataTables"][data.SURVEYEFFORT].length - 1
    });
    //child records change position as well, for every observation table,
    //otherwise a blank form left over from the previous search gets filled
    //in with that search's survey_ts
    new Set([data.SURVEYPRIMARY, data.SURVEYSECONDARY, data.SURVEYTERTIARY])
      .forEach((table) => {
        if (table) {
          appStore.dispatch("shared/shiftPosition", {
            table: table,
            position: -1
          });
        }
      });
    return record;
  },
  saveLocal: async (key, record) => {
    const oldRecord = await localforage.getItem(key);
    const oldRecordWithoutSub = { ...oldRecord };
    delete oldRecordWithoutSub.submitted;
    delete oldRecordWithoutSub.edit_ts;
    delete oldRecordWithoutSub.data;
    const recordWithoutSub = { ...record };
    delete recordWithoutSub.submitted;
    delete recordWithoutSub.edit_ts;
    delete recordWithoutSub.data;
    //If the record has changed (excluding the submit flag) then change the submitted flag and edit_ts
    if (
      JSON.stringify(oldRecordWithoutSub) !== JSON.stringify(recordWithoutSub)
    ) {
      record.submitted = false; //reset submitted flag if record has changed
      record.edit_ts = new Date().toISOString(); //set edit timestamp
    } else if (oldRecord) {
      //nothing changed so keep the stored submitted state, otherwise a stale
      //in-memory copy re-flags an already submitted record for upload
      record.submitted = oldRecord.submitted;
      record.edit_ts = oldRecord.edit_ts;
    }
    return localforage
      .setItem(key, JSON.parse(JSON.stringify(record)))
      .then((value) => {
        console.log(value);
        return value;
      })
      .catch((err) => {
        console.log(err);
      });
  },

  //Data table rows downloaded from the database (search-trials edits existing
  //rows rather than creating new ones). Each row is stored as already
  //submitted, with a baseline copy of the server row for mergeWithServer. Rows
  //with a local edit that hasn't been uploaded yet keep the local version.
  //Returns the records to show in the store.
  async saveDownloadedRecords(table, records) {
    const db = appStore.getters["shared/dbName"];
    //these used to be saved through saveRecord, which built the key from
    //fields these tables don't have and flagged the row for upload
    const keys = await localforage.keys();
    await localforage.removeItems(
      keys.filter((key) => key.startsWith(`${db}-${table}undefined`))
    );
    return Promise.all(
      records.map(async (serverRow) => {
        const key = `${db}-${this.tableSpecificKey(table, serverRow)}`;
        const local = await localforage.getItem(key);
        if (local && local.submitted === false) {
          return local;
        }
        const row = { ...serverRow, table: table, submitted: true };
        await localforage.setItem(key, row);
        await localforage.setItem(this.baselineKey(table, serverRow), serverRow);
        return row;
      })
    );
  },
  //doesn't start with "<db>-<table>" so submitRecords never picks it up
  baselineKey(table, record) {
    return `${appStore.getters["shared/dbName"]}-base-${this.tableSpecificKey(
      table,
      record
    )}`;
  },
  //The upload endpoints overwrite every column, so a downloaded row uploaded
  //as is would undo any edit made in the database since it was downloaded.
  //For rows with a baseline, upload the current server row with only the
  //fields changed locally since the baseline. Records without a baseline
  //(everything the other apps create) are returned unchanged.
  async mergeWithServer(table, records) {
    const bases = await Promise.all(
      records.map((record) =>
        localforage.getItem(this.baselineKey(table, record))
      )
    );
    if (!bases.some((base) => base)) {
      return records;
    }
    let serverRows;
    try {
      const response = await axios.get(
        `${appStore.getters["shared/dbName"]}/public/${table}/`
      );
      serverRows = new Map(
        response.data.map((row) => [this.tableSpecificKey(table, row), row])
      );
    } catch (err) {
      console.log(`could not refresh ${table} before submitting`, err);
      return records;
    }
    const header = this.getFields(table);
    const localFields = ["submitted", "edit_ts", "table", "invalid", "data"];
    const normalize = (v) =>
      JSON.stringify(v === undefined || v === "" ? null : v);
    return records.map((record, i) => {
      const server = serverRows.get(this.tableSpecificKey(table, record));
      if (!bases[i] || !server) {
        return record;
      }
      //compare like with like, records have been through forceFieldTypes
      let base = JSON.parse(JSON.stringify(bases[i]));
      if (header !== undefined) {
        base = this.forceFieldType(header, base);
      }
      const upload = { ...server };
      const fields = new Set([...Object.keys(record), ...Object.keys(base)]);
      for (const field of fields) {
        if (localFields.includes(field)) {
          //keep edit_ts so markSubmitted recognises the upload
          if (field in record) {
            upload[field] = record[field];
          }
        } else if (normalize(record[field]) !== normalize(base[field])) {
          upload[field] = record[field] === undefined ? null : record[field];
        }
      }
      return upload;
    });
  },

  //Uses table unique key columns to create a unique id.
  //Uses key fields extracted from table field specifications
  tableSpecificKey(table, record) {
    if (Object.keys(appStore.state.app.refTables).includes(table)) {
      return `${table}${record.code}`;
    } else {
      let keyFields = this.getFields(table)
        .filter((el) => el.keyField === true)
        .map((el) => record[el.key]);
      let ukey = keyFields.join("");
      return `${table}${ukey}`;
    }
  },
  async savePhotoLocally(table, photoData) {
    let key = `${appStore.getters["shared/dbName"]}-${table}${photoData.ts}`;
    const photo_record = { ...photoData };
    const payload = {
      ...photoData,
      filename: photoData.photo_file_name,
      photoData: photoData.data
    };
    if (!photoData.submitted || photoData.submitted === undefined) {
      //submitted is false so submit then save attributes
      this.submitSinglePhoto(payload)
        .then((result) => {
          delete photo_record.data;
          delete photo_record.photoData;
          this.saveLocal(key, photo_record) //save without photo data
            .then((result) => {
              //this is where we need to update the table data in the store
              localforage
                .startsWith(`${appStore.getters["shared/dbName"]}-${table}`)
                .then((lf) => {
                  appStore.dispatch("shared/refreshRecords", {
                    tableType: "dataTables",
                    tableName: table,
                    records: Object.values(lf)
                  });
                });
            });
        })
        .catch((result) => {
          this.saveLocal(key, photo_record) //save without photo data
            .then((saveresult) => {
              //this is where we need to update the table data in the store
              localforage
                .startsWith(`${appStore.getters["shared/dbName"]}-${table}`)
                .then((lf) => {
                  appStore.dispatch("shared/refreshRecords", {
                    tableType: "dataTables",
                    tableName: table,
                    records: Object.values(lf)
                  });
                });
            });
        });
    } else {
      //submitted is true so just save attributes
      delete photo_record.data;
      delete photo_record.photoData;
      this.saveLocal(key, photo_record) //save without photo data
        .then((saveresult) => {
          //this is where we need to update the table data in the store
          localforage
            .startsWith(`${appStore.getters["shared/dbName"]}-${table}`)
            .then((lf) => {
              appStore.dispatch("shared/refreshRecords", {
                tableType: "dataTables",
                tableName: table,
                records: Object.values(lf)
              });
            });
        });
    }
    //after savelocal repopulate data tables photo table
  },
  async saveObservationLocally(table, record) {
    //the search only exists in memory until something saves it, so save it
    //along with the observation like dropping a breadcrumb does, otherwise the
    //observation can be uploaded with a survey_ts that has no survey_effort
    const survey = (appStore.getters["shared/dataTables"][data.SURVEYEFFORT] || []).find(
      (el) =>
        el.survey_ts === record.survey_ts &&
        el.survey_tablet === record.survey_tablet
    );
    if (survey) {
      await this.saveRecord(data.SURVEYEFFORT, survey);
    }
    let key = `${appStore.getters["shared/dbName"]}-${table}${record.survey_ts}${record.survey_tablet}${record.observation_ts}`;
    //callers rely on this resolving only once the record has actually
    //landed in localforage, so submitData isn't racing this write
    await this.saveLocal(key, record);
    localforage.getItem(key).then((res) => {
      console.log(res);
    });
  },
  saveSurveyEffortLocally(record) {
    let key = `${appStore.getters["shared/dbName"]}-${data.SURVEYEFFORT}${record.survey_ts}${record.survey_tablet}`;
    this.saveLocal(key, record);
    localforage.getItem(key).then((res) => {
      console.log(res);
    });
  },
  saveBreadCrumbLocally(record) {
    let key = `${appStore.getters["shared/dbName"]}-${data.SURVEYBREADCRUMB}${record.survey_ts}${record.survey_tablet}${record.ts}`;
    this.saveLocal(key, record);
    localforage.getItem(key).then((res) => {
      console.log(res);
    });
  },

  saveReferenceTable: async (table, record) => {
    try {
      const value = await localforage.setItem(table + record.code, record);
      return value;
    } catch (err) {
      console.log(err);
      console.log("could not save reference record");
    }
  },
  hasCrumbs(surveyRecord) {
    let filtered = appStore.getters["shared/dataTables"][
      data.SURVEYBREADCRUMB
    ].filter(function (el) {
      return (
        (el["survey_tablet"] === surveyRecord.survey_tablet) &
        (el["survey_ts"] === surveyRecord.survey_ts)
      );
    });
    return filtered.length > 0;
  },
  getLocalTimestamp: function (e) {
    let ts = new Date(e);
    return `${ts.getFullYear()}-${String(ts.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(ts.getDate()).padStart(2, "0")} ${String(
      ts.getHours()
    ).padStart(2, "0")}:${String(ts.getMinutes()).padStart(2, "0")}:${String(
      ts.getSeconds()
    ).padStart(2, "0")}`;
  },
  provideRecord(tableName) {
    if (appStore.getters["shared/tablePositions"][tableName] == -1) {
      return reactive(this.newRecord(tableName));
    } else {
      return reactive(
        appStore.getters["shared/dataTables"][tableName][
          appStore.getters["shared/tablePositions"][tableName]
        ]
      );
    }
  },
  findRecordPosition(table, record) {
    let records = appStore.getters["shared/dataTables"][table];
    let index = -1;
    switch (table) {
      case data.SURVEYEFFORT:
        index = records.findIndex(
          (x) =>
            x.survey_tablet === record.survey_tablet &&
            this.parseTimestamp(x.survey_ts).getTime() ===
              this.parseTimestamp(record.survey_ts).getTime()
        );
        break;
    }
    return index;
  },
  setListPosition(table, position) {
    appStore.dispatch("shared/shiftPosition", {
      table: table,
      position: position
    });
  },
  newRecord(tableName) {
    switch (tableName) {
      case data.SURVEYBREADCRUMB:
        return this.newBreadCrumb();
      case data.SURVEYEFFORT:
        return this.newSurveyEffort();
      case data.SURVEYPRIMARY:
        return this.makeNewObservation(tableName);
      case data.SURVEYSECONDARY:
        return this.makeNewObservation(tableName);
      case data.SURVEYTERTIARY:
        return this.makeNewObservation(tableName);
    }
  },

  populateReferenceTables() {
    Object.keys(appStore.getters["shared/refTables"]).forEach(async (key) => {
      this.getApiRefData(key);
    });
  },
  populateViews() {
    Object.keys(appStore.getters["shared/views"]).forEach(async (key) => {
      this.getViewApiData(key);
    });
  },
  clearDataStore() {
    Object.keys(appStore.getters["shared/dataTables"]).forEach(async (key) => {
      appStore.dispatch("shared/refreshRecords", {
        tableName: key,
        records: [],
        tableType: "dataTables"
      });
    });
  },
  //Upload every table and show one message summarising all of them, rather
  //than a message per table that hides the ones before it
  async submitData() {
    appStore.commit("shared/setAttribute", {
      attribute: "submittedMessages",
      value: "Submitting...",
    });
    const tables = new Set([
      data.SURVEYEFFORT,
      ...Object.keys(appStore.getters["shared/dataTables"]).filter(
        (el) => el != ""
      ),
    ]);
    const results = await Promise.all(
      [...tables].map((t) => this.submitRecords(t))
    );
    const plural = (n) => `${n} record${n === 1 ? "" : "s"}`;
    if (results.some((r) => r.offline)) {
      const waiting = results.reduce((sum, r) => sum + r.failed, 0);
      appStore.commit("shared/setAttribute", {
        attribute: "submittedMessages",
        value: `Could not reach the server, check your connection. ${plural(
          waiting
        )} saved on the device waiting to upload.`,
      });
      return;
    }
    const lines = results
      .filter((r) => r.uploaded || r.failed || r.unchanged)
      .map((r) => {
        const parts = [];
        if (r.uploaded) {
          parts.push(`${plural(r.uploaded)} uploaded`);
        }
        if (r.failed) {
          parts.push(`${plural(r.failed)} failed to upload`);
        }
        if (r.unchanged) {
          parts.push(`no edits to submit on ${plural(r.unchanged)}`);
        }
        return `${r.table}: ${parts.join(", ")}`;
      });
    appStore.commit("shared/setAttribute", {
      attribute: "submittedMessages",
      value: lines.length ? lines.join("\n") : "No records to submit",
    });
  },
  //Resolves to { table, uploaded, failed, unchanged, offline } where unchanged
  //counts records still on the device that were already submitted and
  //haven't been edited since
  async submitRecords(table) {
    const prefix = `${appStore.getters["shared/dbName"]}-${table}`;
    await this.removeOldRecords({
      table: table,
      records: await localforage.startsWith(prefix),
    });
    const result = await localforage.startsWith(prefix);
    //only upload records that haven't been successfully submitted,
    //re-sending submitted records overwrites edits made in the database
    const unsubmitted = Object.entries(result).filter(
      ([, record]) => record.submitted !== true
    );
    const unchanged = Object.keys(result).length - unsubmitted.length;
    const storageKeys = unsubmitted.map(([key]) => key);
    let records = unsubmitted.map(([, record]) => record);
    if (table.includes("photo")) {
      //photo tables get their image data removed before submitting
      const photos = records.filter(
        (record) => record.data !== undefined && record.submitted === false
      );
      photos.forEach((photo) => {
        const payload = {
          ...photo,
          filename: photo.photo_file_name,
          photoData: photo.data,
        };
        this.submitSinglePhoto(payload);
      });
      records = records.map((record) => {
        const newobj = { ...record };
        // Delete the specific property from the new object
        delete newobj.data;
        return newobj;
      });
    }
    const payload = await this.mergeWithServer(
      table,
      this.forceFieldTypes(table, records)
    );
    const submitted = await this.submit({
      table: table,
      key: "u",
      storageKeys: storageKeys,
      payload: payload,
    });
    return { table: table, unchanged: unchanged, ...submitted };
  },
  submitSinglePhoto(payload) {
    return new Promise((resolve, reject) => {
      const dbName = appStore.getters["shared/dbName"];
      axios
        .post(`${dbName}/write_photo/`, payload, {
          headers: { "Content-Type": "application/json" }
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data != "error") {
              payload["submitted"] = true;
              resolve(payload);
            }
          } else {
            console.log("failed to write photo");
            resolve(payload);
          }
        })
        .catch((err) => {
          reject(payload);
          console.log("failed to reach server when writing photo");
        });
    });
  },
  startWatch: function () {
    let geoOptions = {
      enableHighAccuracy: true,
      maximumAge: 15000,
      timeout: 5000
    };
    navigator.geolocation.getCurrentPosition(
      this.updateLocation.bind(this),
      this.locationError,
      geoOptions
    );
    this.watchID = navigator.geolocation.watchPosition(
      this.updateLocation.bind(this),
      this.locationError,
      geoOptions
    );
    this._visibilityHandler = () => {
      if (document.visibilityState === "visible") {
        navigator.geolocation.getCurrentPosition(
          this.updateLocation.bind(this),
          this.locationError,
          { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
        );
      }
    };
    document.addEventListener("visibilitychange", this._visibilityHandler);
  },
  stopWatch: function () {
    navigator.geolocation.clearWatch(this.watchID);
    if (this._visibilityHandler) {
      document.removeEventListener("visibilitychange", this._visibilityHandler);
      this._visibilityHandler = null;
    }
  },
  turnGPSOn: function () {
    if (!appStore.state.shared.gpsOn) {
      this.startWatch();
      appStore.commit("shared/setGPSState", false);
    }
  },
  turnGPSOff: function () {
    if (appStore.state.shared.gpsOn) {
      this.stopWatch();
      appStore.commit("shared/setGPSState", false);
    }
  },
  gpsToggle: function () {
    if (appStore.state.shared.gpsOn) {
      this.startWatch();
    } else {
      this.stopWatch();
    }
  },
  getLatitude() {
    if (appStore.state.shared.coordinates != null) {
      return appStore.state.shared.coordinates.latitude;
    } else {
      return 0.0;
    }
  },
  getLongitude() {
    if (appStore.state.shared.coordinates != null) {
      return appStore.state.shared.coordinates.longitude;
    } else {
      return 0.0;
    }
  },
  updateLocation: function (position) {
    if (Date.now() - position.timestamp > MAX_FIX_AGE_MS) {
      navigator.geolocation.getCurrentPosition(
        this.updateLocation.bind(this),
        this.locationError,
        { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
      );
      return;
    }
    if (position.coords.accuracy < ACCURACY_THRESHOLD) {
      appStore.commit("shared/setCoordinates", position.coords);
    }
  },
  locationError: function (err) {
    console.log("location error: " + err.message);
  },
  asBoolean(strvalue) {
    if (strvalue == "true") {
      return true;
    }
    return false;
  },
  asString(boolval) {
    if (boolval) {
      return "true";
    }
    return "false";
  },

  /**
   * Iteratively reduces JPEG quality of a canvas until it's under the target size.
   * @param {HTMLCanvasElement} canvas - The canvas containing the image.
   * @param {number} targetBytes - The target size in bytes (default 250,000 for 0.25MB).
   * @returns {string} - The compressed data URL.
   */
  compressImage(canvas, targetBytes = 250000) {
    let quality = 0.9;
    let dataUrl = canvas.toDataURL("image/jpeg", quality);

    // Iteratively reduce quality if file size is over targetBytes
    // Base64 string length * 0.75 is a good approximation of the byte size
    while (dataUrl.length * 0.75 > targetBytes && quality > 0.1) {
      quality -= 0.1;
      dataUrl = canvas.toDataURL("image/jpeg", quality);
    }

    return dataUrl;
  }
};
